import { of, } from 'rxjs';
import { LOADING, } from '@ezugi/constants';
import { actions, } from '@ezugi/bootstrap';
import { ls, } from '@ezugi/utils';

import statisticsActions from '../../actions/statistics';
import { PLAYER_A_CARD_HAND, PLAYER_B_CARD_HAND, } from '../../../constants/cards';
import cardsActions from '../../actions/cards';
import { NO_WELCOME_DIALOG, WELCOME_DIALOG, } from '../../../constants/strings';

const {
  dialogActions: { dialog, },
  socketActions: { socket, },
  videoActions: { video, },
  roundActions: { round, },
  settingsActions: { settings, },
  betActions: { bet, history, },
} = actions;

const [ err, noWelcomeDialog, ] = ls.get(NO_WELCOME_DIALOG);

export default function handleInitialData(socketMessage) {
  const {
    VideoStreamData,
    roundId,
    timeStamp,
    RoundTripStartTime,
    playerACards,
    playerBCards,
    regularBets,
    sideBets,
    Statistics,
  } = socketMessage;

  return of(
    socket.success(socketMessage),
    settings.init(),
    video.set({ streamData: VideoStreamData, }),
    statisticsActions.statistics.set(Statistics),
    round.set({
      roundStatus: LOADING,
      roundId,
      roundTime: RoundTripStartTime,
      timestamp: timeStamp,
    }),
    bet.apply({
      current: [ ...regularBets, ...sideBets, ].reduce((acc, { type, betAmount, approved, }) => ({
        ...acc,
        [type]: {
          value: betAmount,
          valid: approved,
        },
      }), {}),
    }),
    // reset history to prevent sending bets to server again
    // because NO_MORE_BETS message comes after this actions
    history.reset(),
    cardsActions.cards.set({
      [PLAYER_A_CARD_HAND]: { cards: playerACards, },
      [PLAYER_B_CARD_HAND]: { cards: playerBCards, },
    }),
    ...(err || !noWelcomeDialog ? [ dialog.add({ name: WELCOME_DIALOG, }), ] : []),
  );
}
